<template>
  <b-container>
    <div class="mt-4 d-flex align-items-start justify-content-between">
      <back-arrow :bilan-type="bilanType" :params="{operationId: operationId}"
                  :sub-title-ope="operationName"
                  :title="$t('Treasury.operation')"
                  routeBack="OperationShow"/>
    </div>

    <div class="mt-2">
      {{ $t('infos.treasury.operation') }}
    </div>

    <!--    A MASQUER-->
    <div v-show="hasEmprunts">
      <div class="mt-2 d-flex align-items-start justify-content-between">
        <h2 class="mb-0 level-two-title bold-text secondary-color">{{ $t('operation.finance.emprunt') }} ce jour</h2>
      </div>

      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12 mt-2 mb-3">
          <treasury-card-component
            :value="convertToEuros(cardTresoValues[0])"
            background-color="emprunts"
            title="treasury.card.emprunt.autorise"/>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-12 mt-2 mb-3">
          <treasury-card-component
            :value="convertToEuros(cardTresoValues[1])"
            background-color="emprunts"
            title="treasury.card.emprunt.debloque"/>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-12 mt-2 mb-3">
          <treasury-card-component
            :value="convertToEuros(cardTresoValues[2])"
            background-color="emprunts"
            title="treasury.card.title.interet.payes"/>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-12 mt-2 mb-3">
          <treasury-card-component
            :value="convertToEuros(cardTresoValues[3])"
            background-color="emprunts"
            title="treasury.card.title.interet.apayer"/>
        </div>
      </div>
    </div>

    <!--    A MASQUER-->
    <div v-show="hasInvestisseurs">
      <div class="mt-1 d-flex align-items-start justify-content-between">
        <h2 class="mb-0 level-two-title bold-text secondary-color">{{ $t('Treasury.onca') }} ce jour</h2>
      </div>

      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12 mt-2 mb-3">
          <treasury-card-component
            :value="convertToEuros(cardTresoValues[4])"
            background-color="investisseurs"
            title="treasury.card.onca.total"/>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-12 mt-2 mb-3">
          <treasury-card-component
            :value="convertToEuros(cardTresoValues[5])"
            background-color="investisseurs"
            title="treasury.card.onca.debloque"/>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-12 mt-2 mb-3">
          <treasury-card-component
            :value="convertToEuros(cardTresoValues[7])"
            background-color="investisseurs"
            title="treasury.card.onca.rembourse"/>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-12 mt-2 mb-3">
          <treasury-card-component
            :value="convertToEuros(cardTresoValues[6])"
            background-color="investisseurs"
            title="treasury.card.title.interet.payes"/>
        </div>
      </div>
    </div>

    <div class="mt-1 d-flex align-items-start justify-content-between">
      <h2 class="mb-0 level-two-title bold-text secondary-color">{{ $t('Treasury.devis.factures') }}</h2>
    </div>

    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12 mt-2 mb-3">
        <treasury-card-component
          :value="convertToEuros(cardTresoValues[8])"
          background-color="devis"
          title="treasury.card.devis.valides"/>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-12 mt-2 mb-3">
        <treasury-card-component
          :value="convertToEuros(cardTresoValues[9])"
          background-color="devis"
          title="treasury.card.factures.sansdevis"/>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-12 mt-2 mb-3">
        <treasury-card-component
          :value="convertToEuros(cardTresoValues[10])"
          background-color="devis"
          title="treasury.card.total.paye"/>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-12 mt-2 mb-3">
        <treasury-card-component
          :value="convertToEuros(cardTresoValues[11])"
          background-color="devis"
          title="treasury.card.restant.apayer"/>
      </div>
    </div>

    <div class="mt-2 flex-row d-flex justify-content-between align-items-center">
      <div class="level-two-title bold-text secondary-color">
        {{ $t('Treasury') }}
      </div>

    </div>

    <b-card class="mt-2 mb-4 shadow-sm">
      <treasury-chart :key="'chart-'+ keyChart"
                      ref="treasuryChart"
                      :card-values="cardValues"
                      :endDate="endDate"
                      :operation-id="operationId"
                      :startDate="startDate"
                      is-global>
      </treasury-chart>
    </b-card>

    <b-card class="mt-2 mb-4 shadow-sm">

      <div class="d-flex align-items-center">
        <multi-date-picker-input ref="periodePicker" @updatePeriode="managePeriode"/>
        <b-link
          v-if="startDate || endDate"
          class="reset-link ml-auto"
          @click="resetPeriode">
          {{ $t('ResetDisplay') }}
        </b-link>
      </div>

      <div class="d-flex mt-3 flex-column flex-md-row justify-content-md-between mb-4">

        <b-input-group
          class="mr-md-4" size="sm"
          style="width: 33%">
          <b-input-group-prepend>
            <b-input-group-text class="search-input-prepend">
              <search-icon size="18"/>
            </b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
            v-model="searchQuery"
            :class="{'active': searchQuery}"
            :placeholder="$t('Research')"
            class="search-input"
            type="search">
          </b-form-input>
        </b-input-group>

        <b122-table-pagination
          :currentPage="currentPage"
          :perPage="perPage"
          :perPageOptions="perPageOptions"
          :totalRows="totalRows"
          class="mt-2 mt-lg-0"
          @changeCurrentPage="changeCurrentPage"
          @changePerPage="changePerPage"/>
      </div>
      <b-table id="table-charges" ref="table"
               :fields="tableFields"
               :items="paginatedItems"
               sticky-header="100px"
               :sort-by="null"
               :tbody-tr-class="getRowClass"
               :thead-class="'b-table-flex-fix row-header'"
               borderless
               class="custom-table-font"
               no-local-sorting
               show-empty
               sort-icon-left
               stacked="lg"
               striped
               @head-clicked="sortBy">
        <template #cell(expense.name)="row">
          <span
            v-if="row.item && row.item.expense && row.item.expense.name && (row.item.expense.name.startsWith('Devis -') || row.item.expense.name.startsWith('Facture -'))"
            class="clickable-label underline-text"
            @click="clickOnLibelle(row)">
            {{ row.item.expense.name }}
          </span>
          <span v-else>
            {{ row.item && row.item.expense ? row.item.expense.name : '' }}
          </span>
        </template>

        <template #cell(date)="row">
          <span>
            {{ new Date(row.item.date).toLocaleDateString('fr-fr') }}
            <template v-if="row.item.initialDate">
              <b-icon
                :id="`info-date-${row.index}`"
                class="ml-2"
                icon="info-circle"
                variant="primary"
              ></b-icon>
              <b-tooltip
                :target="`info-date-${row.index}`"
                html
                variant="dark"
              >
                Date précédente : {{ new Date(row.item.initialDate).toLocaleDateString('fr-fr') }}
              </b-tooltip>
            </template>
          </span>
        </template>


        <template #cell(montant)="row">
          <span>
            {{ convertToEuros(row.item.montant) }}
            <template v-if="row.item.initialMontant">
              <b-icon
                :id="`info-montant-${row.index}`"
                class="ml-2"
                icon="info-circle"
                variant="primary"
              ></b-icon>
              <b-tooltip
                :target="`info-montant-${row.index}`"
                html
                variant="dark"
              >
                Valeur précédente : {{ convertToEuros(row.item.initialMontant) }}
              </b-tooltip>
            </template>
          </span>
        </template>

        <template #cell(soldeTreso)="row">
            <span v-if="row.item.courbe === 'societe'"
                  v-b-tooltip.hover.bottom="{ title: convertToEuros(row.item.montant), customClass: 'white-tooltip' }"
                  class="bold-solde cursor-default">
              {{ convertToEuros(row.item.solde) }}

              <!-- Icône si provenance forcée = Trésorerie (3) -->
              <template v-if="row.item.takeFrom === 3">
                <b-icon
                  :id="`info-treso-${row.index}`"
                  class="ml-2"
                  icon="info-circle"
                  variant="primary"
                />
                <b-tooltip :target="`info-treso-${row.index}`" html variant="dark">
                  Provenance des fonds forcée : Trésorerie
                </b-tooltip>
              </template>
            </span>
            <span v-else
                  v-b-tooltip.hover.bottom="{ title: convertToEuros(row.item.montant), customClass: 'white-tooltip' }"
                  class="cursor-default">
              {{ convertToEuros(row.item.soldeTreso) }}
            </span>
        </template>

        <template #cell(soldeEmprunt)="row">
            <span v-if="row.item.courbe === 'emprunt'"
                  v-b-tooltip.hover.bottom="{ title: convertToEuros(row.item.montant), customClass: 'white-tooltip' }"
                  class="bold-solde cursor-default">
              {{ convertToEuros(row.item.solde) }}

              <!-- Icône si provenance forcée = Emprunt (1) -->
              <template v-if="row.item.takeFrom === 1">
                <b-icon
                  :id="`info-emprunt-${row.index}`"
                  class="ml-2"
                  icon="info-circle"
                  variant="primary"
                />
                <b-tooltip :target="`info-emprunt-${row.index}`" html variant="dark">
                  Provenance des fonds forcée : Emprunt
                </b-tooltip>
              </template>
            </span>
            <span v-else
                v-b-tooltip.hover.bottom="{ title: convertToEuros(row.item.montant), customClass: 'white-tooltip' }"
                class="cursor-default">
              {{ convertToEuros(row.item.soldeEmprunt) }}
            </span>
        </template>

        <template #cell(soldeInvestisseur)="row">
            <span v-if="row.item.courbe === 'investor'"
                  v-b-tooltip.hover.bottom="{ title: convertToEuros(row.item.montant), customClass: 'white-tooltip' }"
                  class="bold-solde cursor-default">
              {{ convertToEuros(row.item.solde) }}

              <!-- Icône si provenance forcée = Investisseurs (2) -->
              <template v-if="row.item.takeFrom === 2">
                <b-icon
                  :id="`info-invest-${row.index}`"
                  class="ml-2"
                  icon="info-circle"
                  variant="primary"
                />
                <b-tooltip :target="`info-invest-${row.index}`" html variant="dark">
                  Provenance des fonds forcée : Investisseurs
                </b-tooltip>
              </template>
            </span>
            <span v-else
                v-b-tooltip.hover.bottom="{ title: convertToEuros(row.item.montant), customClass: 'white-tooltip' }"
                class="cursor-default">
              {{ convertToEuros(row.item.soldeInvestisseur) }}
            </span>
        </template>

        <template #cell(verifie)="row">
          <img v-if="row.item.verifie"
               :src="require(`@/assets/images/ic-checked.png`)"
               alt="folder"
               class="verifie-icon checked"
               height="26px"
               width="auto"
               @click="updateVerifie(row)">
          <img v-else
               :src="require(`@/assets/images/ic-check.png`)"
               alt="folder"
               class="verifie-icon unchecked"
               height="26px"
               width="auto"
               @click="updateVerifie(row)">
        </template>

        <template #cell(edit)="row">
          <button v-if="row.item.objectUUID" class="show-action-btn edit mr-1" @click="clickOnEditBtn(row)">
            <pencil-icon size="18"/>
          </button>
        </template>
      </b-table>
      <b122-table-pagination
        :currentPage="currentPage"
        :perPage="perPage"
        :perPageOptions="perPageOptions"
        :totalRows="totalRows"
        class="mt-2 mt-lg-0"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"/>
    </b-card>

    <treasury-override-modal
      v-if="movement"
      id="treasury-override-modal"
      :key="'tresomodal-' + treasuryModalKey"
      :movement="movement"
      @didCloseModal="fetchTreasuryMovements(true)"/>

  </b-container>
</template>

<script>

import B122Table from "../../components/b122/B122Table";
import ItemDeleteModal from "../../components/b122/ItemDeleteModal";
import TreasuryChart from "./TreasuryChart";
import CardComponent from "../../components/b122/CardComponent";
import BackArrow from "../../components/b122/BackArrow";
import api from "../../services/api";
import b122TablePagination from "../../components/b122/B122TablePagination";
import TreasuryCardComponent from "../../components/TreasuryCardComponent.vue";
import MultiDatePickerInput from "../../components/b122/editFields/MultiDatePickerInput.vue";
import TreasuryOverrideModal from "./TreasuryOverrideModal.vue";
import i18n from "../../i18n";

export default {
  name: "TreasuryShow",


  components: {
    TreasuryOverrideModal,
    MultiDatePickerInput,
    TreasuryCardComponent,
    B122Table,
    ItemDeleteModal,
    TreasuryChart,
    CardComponent,
    BackArrow,
    b122TablePagination
  },

  data() {
    return {
      operationId: this.$route.params.operationId,
      username: this.$store.getters.username,
      isEstateAgent: this.$store.getters.isEstateAgent,
      treasuryMovementId: null,
      bilanType: null,
      operationName: '',
      cardValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      cardTresoValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      itemsCharges: [],
      searchQuery: '',
      currentSortKey: 'date',
      currentSortOrder: 'asc',
      currentPage: 1,
      perPage: 50,
      startDate: 0,
      endDate: 0,
      keyChart: 0,
      treasuryModalKey: 0,
      movement: null,
      perPageOptions: [
        {
          value: 10,
          text: '10 ' + this.$i18n.t('perPage')
        },
        {
          value: 50,
          text: '50 ' + this.$i18n.t('perPage')
        },
        {
          value: 100,
          text: '100 ' + this.$i18n.t('perPage')
        },
        {
          value: 2147483647,
          text: this.$i18n.t('seeEverything')
        }
      ],
      totalRows: 0,
    }
  },

  watch: {
    filteredItems(newFilteredItems) {
      this.totalRows = newFilteredItems.length;
    },
  },

  async mounted() {
    await this.fetchOperation()
    await this.fetchTreasuryMovements()
  },

  methods: {

    sortBy(key) {
      if (this.currentSortKey === key) {
        this.currentSortOrder = this.currentSortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.currentSortKey = key;
        this.currentSortOrder = 'asc';
      }
    },

    managePeriode(startDate, endDate) {
      this.startDate = startDate;
      this.endDate = endDate;
      this.keyChart++
      this.fetchTreasuryMovements();
    },

    resetPeriode() {
      this.startDate = 0;
      this.endDate = 0;
      this.keyChart++
      this.fetchTreasuryMovements();
      if (this.$refs.periodePicker && this.$refs.periodePicker.reset) {
        this.$refs.periodePicker.reset()
      }
    },

    changeCurrentPage(newCurrentPage) {
      this.currentPage = newCurrentPage
    },

    changePerPage(newPerPage) {
      this.perPage = newPerPage
      this.currentPage = 1
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'TreasuryMovementShow',
        params: {
          movementId: row.item.id
        }
      })
    },

    clickOnLibelle(row) {
      const name = row.item && row.item.expense ? row.item.expense.name : ''
      if (!name) {
        return
      }

      if (name.startsWith('Devis -')) {

        if (row.item.devisId) {
          this.$router.push({
            name: 'OperationDevisFactureShow',
            params: {operationId: this.operationId, devisId: row.item.devisId}
          })
        }
      } else if (name.startsWith('Facture -')) {

        if (row.item.factureId) {
          this.$router.push({
            name: 'OperationFactureShow',
            params: {operationId: this.operationId, factureId: row.item.factureId}
          })
        }
      }
    },


    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    convertToEuros(value) {
      return Intl.NumberFormat().format(value) + " €"
    },

    async fetchOperation() {
      await api
        .get(`/operation/${this.operationId}`)
        .then(response => {
          this.operationName = response.data.name
          this.bilanType = response.data.bilanType
        })
    },

    async fetchTreasuryMovements(fromOverrideModal = false) {
      try {
        let url = `/treasury/getAllTreasuryMovementAndEvenementForOperationTable/${this.operationId}`
        const response = await api.get(url, {
          params: {startDate: this.startDate, endDate: this.endDate},
        });
        this.cardTresoValues = response.data.cardTresoValues
        this.itemsCharges = [...response.data.societe, ...response.data.investor, ...response.data.emprunts];

        if (this.startDate && this.endDate) {
          this.itemsCharges.unshift({
            date: response.data.debutSolde.date,
            expense: {name: "Début solde"},
            montant: 0,
            soldeTreso: response.data.debutSolde.treso,
            soldeEmprunt: response.data.debutSolde.emprunt,
            soldeInvestisseur: response.data.debutSolde.invest
          })
          this.itemsCharges.push({
            date: response.data.finSolde.date,
            expense: {name: "Fin solde"},
            montant: 0,
            soldeTreso: response.data.finSolde.treso,
            soldeEmprunt: response.data.finSolde.emprunt,
            soldeInvestisseur: response.data.finSolde.invest
          })
        }

        this.totalRows = this.itemsCharges.length


      } catch (error) {
        console.error(error);
      }
      this.keyChart++
    },


    matchesSearch(item, searchLower) {
      if (item === null || item === undefined) {
        return false;
      }
      if (typeof item === 'object') {
        return Object.values(item).some(val => this.matchesSearch(val, searchLower));
      }
      return String(item).toLowerCase().includes(searchLower);
    },

    getValueByKey(item, key) {
      return key.split('.').reduce((obj, keyPart) => (obj && obj[keyPart] !== undefined) ? obj[keyPart] : null, item);
    },

    async clickOnEditBtn(row) {
      let formData = new FormData()
      formData.append("objectUUID", row.item.objectUUID)

      await api
        .post(`/treasury/getOverrideMovement`, formData)
        .then(response => {
          this.movement = response.data[0]
          this.treasuryModalKey++
          setTimeout(() => {
            this.$bvModal.show('treasury-override-modal')
          }, 100);

        })
    },

    async updateVerifie(row) {
      const data = new FormData();
      data.append('objectUUID', row.item.objectUUID);
      data.append('verifie', !row.item.verifie);

      let url = `/treasury/updateMovementOverrideVerifie`

      try {
        const response = await api({
          method: 'POST',
          url: url,
          data: data
        });
        row.item.verifie = response.data.treasuryMovementOverride.verifie;
      } catch (error) {
        console.error(error);
      }
    },

    getRowClass(item, type) {
      if (!item || type !== 'row') return '';

      if (item.expense && item.expense.name) {
        const expenseName = item.expense.name.toLowerCase();
        if (expenseName.includes('devis -')) {
          return 'devis-row';
        }
      }

      return '';
    }
  },

  computed: {

    filteredItems() {
      const searchLower = this.searchQuery.trim().toLowerCase();
      let filteredData = this.itemsCharges;

      if (searchLower) {
        filteredData = filteredData.filter(item => this.matchesSearch(item, searchLower));
      }

      if (this.currentSortKey) {
        filteredData.sort((a, b) => {
          let aValue = this.getValueByKey(a, this.currentSortKey);
          let bValue = this.getValueByKey(b, this.currentSortKey);

          if (this.currentSortKey === 'date') {
            aValue = aValue ? new Date(aValue).getTime() : 0;
            bValue = bValue ? new Date(bValue).getTime() : 0;
          }

          if (!isNaN(aValue) && !isNaN(bValue)) {
            aValue = Number(aValue);
            bValue = Number(bValue);
          }

          if (aValue < bValue) return this.currentSortOrder === 'asc' ? -1 : 1;
          if (aValue > bValue) return this.currentSortOrder === 'asc' ? 1 : -1;
          return 0;
        });
      }


      return filteredData;
    },

    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredItems.slice(start, end);
    },

    tableFields() {
      return [
        {
          label: this.$t('chargePro.Date'),
          key: 'date',
          sortable: true,
        },
        {
          label: this.$t('chargePro.Libelle'),
          key: 'expense.name',
          sortable: true
        },
        {
          label: this.$t('Mouvement'),
          key: 'montant',
          sortable: true
        },
        {
          label: this.$t('treasury.chart.societe'),
          key: 'soldeTreso',
          sortable: true
        },
        {
          label: this.$t('treasury.chart.emprunts'),
          key: 'soldeEmprunt',
          sortable: true
        },
        {
          label: this.$t('treasury.chart.investor'),
          key: 'soldeInvestisseur',
          sortable: true
        },
        {
          label: this.$t('treasury.chart.verifie'),
          key: 'verifie',
          sortable: true
        },
        {
          label: this.$t('Actions'),
          key: 'edit',
        }]
    },
    hasEmprunts() {
      return this.cardTresoValues.slice(0, 4).some(value => value !== 0);
    },

    hasInvestisseurs() {
      return this.cardTresoValues.slice(4, 8).some(value => value !== 0);
    },
  },
}
</script>

<style scoped>

.investor {
  height: 20px;
  width: 10px;
  background-color: #06C9B3;
}

.societe {
  height: 20px;
  width: 10px;
  background-color: #6D84C4;
}

.emprunt {
  height: 20px;
  width: 10px;
  background-color: #9E0430;
}

.custom-table-font {
  font-family: "Montserrat-Regular", "Arial", sans-serif;
  font-weight: 500;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0;
  color: var(--main-text-color);

}

.bold-solde {
  font-family: "Montserrat-Bold", "Arial", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
}

#table-charges >>> th[role="columnheader"] {
  vertical-align: middle;
  color: var(--secondary-text-color);
  font-weight: 400;
  font-family: "Montserrat-Regular", "Arial", sans-serif;
}

#table-charges >>> td[role="cell"] {
  vertical-align: middle;
  color: var(--main-color-text);
}

#table-charges >>> tr.devis-row {
  background-color: #fceccf !important;
}

#table-charges >>> tr.devis-row td {
  background-color: #fceccf !important;
}

.verifie-icon {
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.verifie-icon.unchecked {
  opacity: 0.5;
  filter: grayscale(100%);
}

.verifie-icon.checked {
  opacity: 1;
  filter: none;
}


.white-tooltip.bs-tooltip-auto[x-placement^='bottom'],
.white-tooltip.bs-tooltip-bottom {
  opacity: 1 !important;
}

.white-tooltip .tooltip-inner {
  background-color: #ffffff !important;
  color: #07153C !important;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.white-tooltip .arrow::before {
  border-bottom-color: #ffffff !important;
}

.cursor-default {
  cursor: default !important;
}

/* Libellé cliquable (Devis / Facture) */
.clickable-label {
  text-decoration: underline;
  cursor: pointer;
  color: var(--main-color);
}
</style>

<style>
/* Styles globaux: tooltips rendus dans <body> */
.white-tooltip.tooltip .tooltip-inner {
  background-color: #ffffff !important;
  color: #07153C !important;
  border: 1px solid #E5E7EB !important;
  border-radius: 6px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
}

.white-tooltip.bs-tooltip-auto[x-placement^='bottom'] .arrow::before,
.white-tooltip.bs-tooltip-bottom .arrow::before {
  border-bottom-color: #ffffff !important;
}

.white-tooltip.bs-tooltip-auto[x-placement^='top'] .arrow::before,
.white-tooltip.bs-tooltip-top .arrow::before {
  border-top-color: #ffffff !important;
}

</style>



// WEBPACK FOOTER //
// src/views/treasury/TreasuryShow.vue